class MapLibreUtils {
    static getColorBySpeed(speed) {
        if (speed < 15) return '#80ff00';
        if (speed < 20) return '#00ffff';
        if (speed < 25) return '#0040ff';
        if (speed < 30) return '#8000ff';
        if (speed < 40) return '#ff00bf';
        return '#ff0000';
    }
}

export default MapLibreUtils;
